<template>
  <div
    v-if="
      (resourceType !== undefined &&
        rights.length > 0 &&
        ![
          RESOURCE_TYPE_CONFIG.MUSIC,
          RESOURCE_TYPE_CONFIG.SOUND_EFFECT,
          RESOURCE_TYPE_CONFIG.FONT,
        ].includes(resourceType)) ||
      showVerify
    "
    class="flex items-baseline flex-wrap font-[400]"
  >
    <iconpark-icon name="diamond3d" class="mr-[8px] translate-y-[2px]" />
    <div class="flex-1">
      {{ $t('sheng-ji-zhi') }}
      <a-popover
        v-for="(r, i) in displayRights"
        :key="r.id"
        placement="bottom"
        destroy-tooltip-on-hide
      >
        <a href="javascript:;" @click="handleClick(r)">
          {{ r.rights_name }}{{ i < displayRights.length - 1 ? '、' : ' ' }}
        </a>
        <template #content>
          <div
            class="w-[80px] text-12 text-font-50 flex-center flex-wrap gap-[4px_8px]"
          >
            <span v-for="x in RESOURCE_TIPS()[resourceType]" :key="x.limit">
              {{ x.label }} ≤ {{ transSize(r[x.limit]) }}M
            </span>
          </div>
        </template>
      </a-popover>
      <template v-if="auxiliary">
        {{ $t('ji-ke-shang-chuan-jie-suo-geng-da-de-wen-jian-da-xiao') }}
      </template>
      <div v-if="showVerify && isChinese()">
        {{ $t('ren-zheng-hou-jie-suo-geng-da-shang-chuan-shang-xian') }}
        {{ $t('comma') }}
        <a
          v-if="userInfo?.permission !== USER_ADMIN.NORMAL && isChinese()"
          @click="goLink"
        >
          {{ $t('qu-ren-zheng') }}
        </a>
        <span v-else>
          {{
            $t('qing-lian-xi-guan-li-yuan-wan-cheng-ren-zheng-hou-shang-chuan')
          }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { USER_LEVEL_KEY, type IEquity } from '~/api/interface'
import { USER_ADMIN } from '~/constants'
import { PageKey } from '~/constants/page'
import { RESOURCE_TIPS, transSize } from '~/hooks/useUpload'
import { getRightsView } from '~/pages/subscribe/components/rights-view'
import Rights10 from '~/pages/subscribe/components/rights-view/rights-10'
import Rights16 from '~/pages/subscribe/components/rights-view/rights-16'
import Rights24 from '~/pages/subscribe/components/rights-view/rights-24'

const props = defineProps<{
  rights: IEquity[]
  resourceType?: number
  auxiliary?: boolean
  showVerify?: boolean
}>()

const emits = defineEmits(['cancel'])
const accountList = useAccountList()
const rightsConfig = useRightsConfig()
const userInfo = useUserInfo()

const displayRights = computed(() => {
  return props.rights.filter(
    (r) => ![USER_LEVEL_KEY.TEAM_TASTE].includes(r.rights_type) //  过滤掉团队体验版，因为没有升级价值
  )
})
const route = useRoute()
const handleClick = (r: IEquity) => {
  const rightsView = getRightsView({
    rights: r,
    userInfo: userInfo.value!,
    accountList: accountList.value,
    overseas: isGlobalVersion() ? rightsConfig.value : null,
  })

  if (rightsView instanceof Rights10) {
    rightsView.newOrder()
  }

  if (rightsView instanceof Rights16) {
    rightsView.newOrder()
  }

  if (rightsView instanceof Rights24) {
    if (route.name === PageKey.HOME_PERSONAL) {
      rightsView.openContact('yygw-grkj-scan')
    }
    if (route.name === PageKey.HOME_TEAM) {
      rightsView.openContact('yygw-gxtdkjtsc-sjqy')
    }
  }
}

const goLink = () => {
  const router = useRouter()
  emits('cancel')
  router.push({
    name: PageKey.ACCOUNT_VERIFY,
  })
}
</script>

<style lang="scss" scoped>
.tip {
  @apply text-12 text-font-50 mt-[20px] p-[12px_14px] bg-back-4 bg-opacity-[0.6] rounded-[8px];
  li {
    &::before {
      content: '';
      @apply inline-block w-[4px] h-[4px] rounded-[2px] mr-[8px] bg-font-1 bg-opacity-50;
      vertical-align: middle;
    }
    & + li {
      @apply mt-[4px];
    }
  }
}
</style>
